// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { getSettingsCollection } from "@steiner/App/Store/Selectors/SettingsSelectors";
import React from "react";

interface MiniContactUsStyles {
    container?: InjectableCss;
    phoneLink?: LinkPresentationProps;
    liveChatLink?: LinkPresentationProps;
    emailLink?: LinkPresentationProps;
    creditApplicationLink?: LinkPresentationProps;
}

export const miniContactUsStyles: MiniContactUsStyles = {};

const styles = miniContactUsStyles;
const MiniContactUs = () => {
    const { phoneNumber, phoneNumberUrl, email, creditApplication } = useAppSelector(state => ({
        phoneNumber: getSettingsCollection(state).customSharedSettings.strContactUsPhoneNumber,
        phoneNumberUrl: getSettingsCollection(state).customSharedSettings.contactUsPhoneNumberUrl,
        email: getSettingsCollection(state).customSharedSettings.strContactUsEmail,
        creditApplication: getSettingsCollection(state).customSharedSettings.contactUsCreditApplication,
    }));

    const windowIfDefined = typeof window === "undefined" ? null : (window as any);

    const onPhoneNumberHandler = () => {
        if (!windowIfDefined) {
            return;
        }

        windowIfDefined.open(phoneNumberUrl, "Callback_RingMe", "resizable=no,width=650,height=460");
    };

    const onLiveChatHandler = () => {
        if (!windowIfDefined || !("OpenLHNChat" in windowIfDefined)) {
            return;
        }

        windowIfDefined.OpenLHNChat();
    };

    return (
        <StyledWrapper {...styles.container} data-test-selector="Mini-ContactUs">
            {phoneNumber && (
                <Link onClick={onPhoneNumberHandler} {...styles.phoneLink}>
                    {phoneNumber}
                </Link>
            )}
            {windowIfDefined && "OpenLHNChat" in windowIfDefined && (
                <Link onClick={onLiveChatHandler} {...styles.liveChatLink}>
                    {translate("Live Chat")}
                </Link>
            )}
            {email && (
                <Link href={`mailto:${email}`} {...styles.emailLink}>
                    {email}
                </Link>
            )}
            {creditApplication && (
                <Link href={creditApplication} {...styles.creditApplicationLink}>
                    {translate("Download Credit Application")}
                </Link>
            )}
        </StyledWrapper>
    );
};

export default MiniContactUs;
